import logo from "./../images/Logo.svg";
import timbertech from "./../images/TimberTechPlatinumPro.png";
import bliffert from "./../images/BliffertLumber.png";

import { CONTACT_INFO } from "../constants/constants";

import { ContactInfo } from "../components/ContactInfo";
import { LogoLink } from "../components/LogoLink";

interface IProps {
  backgroundColor: string;
}

export const SimpleFooter = ({ backgroundColor }: IProps) => {
  return (
    <footer className={`${backgroundColor}`}>
      <div
        className={
          "flex flex-col lg:flex-row flex-wrap relative w-2/3 content-center place-self-center lg:items-center lg:justify-between p-16 gap-16 text-xl text-primary-800"
        }
      >
        <div className={"flex flex-col items-center justify-center"}>
          <a href={"/"} className={"flex h-40 w-48 lg:w-64"}>
            <img
              className={"object-cover object-bottom"}
              src={logo}
              alt={"logo"}
              loading={"lazy"}
            />
          </a>
          <hr className={"w-full mt-2 border-primary-500"} />
          <ul className={"flex flex-row"}>
            <li className={"w-20 lg:w-28"}>
              <LogoLink
                href={"https://www.doitbest.com/bliffert-lumber-and-hardware/"}
                src={bliffert}
                alt={"Bliffert Lumber Logo"}
              />
            </li>
            <li className={"w-20 lg:w-28"}>
              <LogoLink
                href={"https://www.timbertech.com/"}
                src={timbertech}
                alt={"TimberTech Logo"}
              />
            </li>
          </ul>
        </div>
        <div>
          <h2
            className={
              "mb-6 text-2xl lg:text-3xl lg:font-medium text-primary-500"
            }
          >
            Contact
          </h2>
          <ContactInfo
            phone={CONTACT_INFO.PHONE}
            email={CONTACT_INFO.EMAIL}
            address={CONTACT_INFO.ADDRESS}
          />
        </div>
      </div>
    </footer>
  );
};
